import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import IntakeForm from "@/pages/IntakeForm";
import Privacy from "@/pages/Privacy";
import Miam from "@/pages/Miam";
import EmailTemplates from "@/pages/EmailTemplates";
import AdminLogin from "@/pages/admin/AdminLogin";
import ForgotPassword from "@/pages/admin/ForgotPassword";
import ResetPassword from "@/pages/admin/ResetPassword";
import EnquiriesDashboard from "@/pages/admin/EnquiriesDashboard";
import Availability from "@/pages/admin/Availability";
import ChatLeads from "@/pages/admin/ChatLeads";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<IntakeForm />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/miam" element={<Miam />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/forgot-password" element={<ForgotPassword />} />
            <Route path="/admin/reset-password" element={<ResetPassword />} />
            <Route path="/admin/enquiries" element={<ProtectedRoute><EnquiriesDashboard /></ProtectedRoute>} />
            <Route path="/admin/availability" element={<ProtectedRoute><Availability /></ProtectedRoute>} />
            <Route path="/admin/chat-leads" element={<ProtectedRoute><ChatLeads /></ProtectedRoute>} />
            <Route path="/admin/email-templates" element={<ProtectedRoute requireAdmin><EmailTemplates /></ProtectedRoute>} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
